import type { TableRowType } from './table.types';
import { TableAutoGeneratedRowType } from './table.types';

export function isGeneratedRow(row?: TableRowType): boolean {
  return row?.crmRowKind === TableAutoGeneratedRowType.AUTO_GENERATED || row?.crmRowKind === TableAutoGeneratedRowType.FLAT_GENERATED;
}

export function isAutoGeneratedRow(row?: TableRowType): boolean {
  return row?.crmRowKind === TableAutoGeneratedRowType.AUTO_GENERATED;
}
